import {
  dateOfBirth,
  dobVerified,
} from '@mgo/core/src/validations/person';

export default {
  dateOfBirth,
  dobVerified,
};
